import './App.css';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import TableComponent from './TableComponent';
import { useEffect, useState } from 'react';

function App() {
  const [xBar, setXBar] = useState('');
  const [x1, setX] = useState('');

  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const addRow = () => {
    if (x1 !== '') {
      let newRows = rows;
      newRows.push(x1);
      setRowCount((count) => {
        return count + 1;
      });
      setX('');
      setRows(newRows);
    }
  };

  const removeRow = () => {
    let newRows = rows;
    newRows.pop();
    setRowCount((count) => {
      return count - 1;
    });
    setRows(newRows);
    setXBar(xBar);
  };

  return (
    <div className="App">
      <h1 className="text-center"> SKEW CALCULATOR </h1>
      <Col sm="6">
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Mean = </InputGroup.Text>
          <Form.Control
            value={xBar}
            type="number"
            placeholder="Enter Mean"
            onChange={(e) => setXBar(e.target.value)}
          />
        </InputGroup>
      </Col>

      <Row>
        <Col sm="5">
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1">X = </InputGroup.Text>
            <Form.Control
              value={x1}
              type="number"
              placeholder="Enter X"
              onChange={(e) => setX(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === '+') {
                  e.preventDefault();
                  addRow();
                }
              }}
            />
          </InputGroup>
        </Col>
        <Col sm="1">
          <Button variant="success" onClick={() => addRow()}>
            {' '}
            +{' '}
          </Button>
        </Col>
        <Col sm="1">
          <Button variant="danger" onClick={() => removeRow()}>
            {' '}
            -{' '}
          </Button>
        </Col>
      </Row>

      {!xBar ? (
        'Enter Mean to Generate Table'
      ) : rows.length ? (
        <TableComponent rows={rows} xBar={xBar} count={rowCount} />
      ) : (
        'Enter atleast one Row to Generate Table'
      )}
    </div>
  );
}

export default App;
